import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const LinkStore = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  
  .area-store {
    display: flex;
    flex-direction: column;
  }
  .qr-code {
    width: 114px;
    height: auto;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  height: 100vh;
  grid-template-columns: 0.3fr 1fr;
  grid-template-rows: 68px 1fr 80px;
  grid-template-areas:
    "header header"
    "nav main"
    "footer footer";
  font-size: max(0.9rem, 0.8vw);

  .header {
    grid-area: header;
  }

  .footer {
    grid-area: footer;
  }

  &.navContraction {
    grid-template-columns: 113px 1fr;
  }

  @media screen and (max-width: 480px) {
    grid-template-areas:
      "header header"
      "main main"
      "footer footer";
  }
`;
export const TextP = styled.span`
`;
export const TextPM = styled.p`
  text-align: justify
`;
export const Header = styled.header`
  grid-area: header;
  width: 100%;
  background-color: ${theme.colors.primaryBlue};
  display: grid;
  align-items: center;
  padding: 0 1rem;

  .rightContent {
    justify-self: end;
    display: flex;
    align-items: center;
    height: 100%;

    .notification {
      position: relative;
      margin-right: 1rem;

      svg {
        color: ${theme.colors.white};

        &:hover {
          cursor: pointer;
          color: ${theme.colors.secondaryLight};
        }
      }

      > span {
        position: absolute;
        bottom: 0;
        top: 10px;
        left: 16px;

      }
    }

    .line {
      display: block;
      width: 1px;
      height: 100%;
      background-color: ${theme.colors.white};
      margin: 0 0.5rem;
      opacity: 0.1;
    }
  }
`;

export const Main = styled.main`
  grid-area: main;
  display: flex;
  flex-direction: column;
  padding: 1rem 2rem 1rem 4rem;
  overflow-y: auto;
  gap: 1rem;

  @media screen and (max-width: 480px) {
    padding: 1rem;
  }
`;

export const Nav = styled.nav`
  grid-area: nav;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadow.btDefault};
  border-radius: 0 0 1.5rem 1.5rem;
  margin-left: 2rem;
  max-height: 952px;
  height: 100%;
  min-width: 50px;
  width: 100%;
  font-size: inherit;

  &.navContraction {
    .link {
      justify-content: center;
    }

    .text {
      display: none;
    }

    .navTop {
      justify-content: center;
      svg.logo {
        display: none;
      }
    }

    .contentButton {
      display: none !important;
    }
  }

  .navTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${theme.colors.white};
    position: relative;
    top: -35px;
    width: 100%;
    border-radius: 1.5rem 1.5rem 0 0;
    padding: 24px;
    padding-bottom: 16px;

    svg.arrow {
      width: 2.1rem;
      height: 2.1rem;

      :hover {
        cursor: pointer;
        transform: scale(1.1);
      }
    }
  }

  .navBottom {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .contentButton {
      width: 100%;
      display: flex;
      justify-content: center;

      button {
        background: ${theme.colors.primaryBlue};
        box-shadow: 0px 5px 8px rgba(25, 50, 128, 0.15);
        border-radius: 8px;
        padding: 1rem;
        color: ${theme.colors.white};
        width: 65%;
        font-size: inherit;
        border: 1px solid ${theme.colors.primaryBlue};
      
        :disabled {
          background-color: #F5F5F5;
          color: #7A7B7A;
          border-radius: 10px;
          padding: 12px 24px;
          font-weight: 400;
          box-shadow: none;
          cursor: not-allowed;
        }
      
        :not(:disabled):hover {
          cursor: pointer;
          background-color: ${theme.colors.white};
          color: ${theme.colors.primaryBlue};
        }
      }
    }

    .navItems {
      width: 100%;
      display: flex;
      flex-direction: column;
      list-style: none;
      padding: 0 1.5rem;
      gap: 0.5rem;
      overflow-y: auto;

      .list {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 0.2rem;

        .link {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 0.5rem;
          color: ${theme.colors.black};

          svg {
            min-width: 1.3rem;
            min-height: 1.3rem;
            color: inherit;
          }

          :hover {
            color: #3755b0;
            cursor: pointer;
          }

          &.active {
            background: #d7dcec;
            border-radius: 0.5rem;
            color: #3755b0;
          }
        }

        @media screen and (max-width: 830px) {
          .link {
            justify-content: center;
          }

          .text {
            display: none;
          }
        }
      }
    }
  }

  .line {
    display: block;
    width: 100%;
    background-color: #f1f2f0;
    height: 1px;
    margin-bottom: 0.2rem;
  }

  @media screen and (max-width: 830px) {
    .navTop {
      justify-content: center;
      svg.logo {
        display: none;
      }
    }
  }

  @media screen and (max-width: 480px) {
    display: none;
  }
`;
